import { IBundle, IApiResponse, IList, IRegion, IService } from "./interface";
import axios from "axios";
import { useQuery } from "react-query";

const mdaCoreApiUrl = "https://api-v3.mydrivingacademy.se";
/*process.env.REACT_APP_MDA_CORE_API_URL;*/

interface IRequestConfig {
  url: string;
  params?: unknown;
}
const axiosApiInstance = axios.create();
export function makeAxiosGetRequest<T>(config: IRequestConfig) {
  return axiosApiInstance
    .get<T>(config.url, {
      params: config.params,
    })
    .then((res) => res.data)
    .catch((e) => Promise.reject(e.response.data));
}

const QUERY_KEY_REGION: string = "regions";

export function getRegions(params?: any): Promise<IList<IRegion>> {
  return makeAxiosGetRequest<IApiResponse<IList<IRegion>>>({
    url: `${mdaCoreApiUrl}/v3/regions/search`,
    params,
  }).then((res) => res.data);
}

export function useRegions(filter?: any) {
  return useQuery<IList<IRegion>>([QUERY_KEY_REGION, filter], () =>
    getRegions(filter)
  );
}

export function getServices(filter?: any): Promise<IList<IService>> {
  const params = filter;
  return makeAxiosGetRequest<IApiResponse<any>>({
    url: `${mdaCoreApiUrl}/v3/services/search`,
    params,
  }).then((res) => res.data);
}
export function useServices(filter?: any, enabled: boolean = true) {
  return useQuery<IList<IService>>(
    ["QUERY_KEY", filter || ""],
    () => getServices(filter),
    {
      enabled: enabled,
    }
  );
}

export const BUNDLES_QUERY_KEY = "bundles";
export function getBundles(filter?: any): Promise<IList<IBundle>> {
  return makeAxiosGetRequest<IApiResponse<IList<IBundle>>>({
    url: `${mdaCoreApiUrl}/v3/bundles/search`,
    params: filter,
  }).then((res) => res.data);
}
export function useBundles(filter?: any) {
  return useQuery<IList<IBundle>>([BUNDLES_QUERY_KEY, filter || ""], () =>
    getBundles(filter)
  );
}
